// ...
import { PayloadAction, configureStore } from '@reduxjs/toolkit';
import appInterfaceDataSliceReducer from './reducer/appInterfaceDataSlice';
import appParentPortalDataSliceReducer from './reducer/appParentPortalDataSlice';
import appStateSliceReducer from './reducer/appStateSlice';
import childProfileDataSliceReducer from './reducer/childProfileDataSlice';
import signupDataSliceReducer from './reducer/signupDataSlice';

//
import { combineReducers } from "redux";
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['appState', 'appInterfaceData', 'signupData', 'childProfileData', 'appParentPortalData'],
};

//
const persistedReducer = persistReducer(persistConfig, combineReducers({
  appState: appStateSliceReducer,
  appInterfaceData: appInterfaceDataSliceReducer,
  signupData: signupDataSliceReducer,
  childProfileData: childProfileDataSliceReducer,
  appParentPortalData: appParentPortalDataSliceReducer,
}));

//
export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) => {
    return getDefaultMiddleware({
      serializableCheck: false,
    })
  },
});

export const persistor = persistStore(store);

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;

export const outsideComponentDispatch = (action: PayloadAction<any>): any => {
  return store.dispatch(action);
};
